import React, { Component } from 'react'

import { Glyphicon } from 'react-bootstrap'

export default class SpinningGlyhicon extends Component {
  static propTypes = {}

  render() {
    if (this.props.fetching) {
      return (
        <div>
          {this.props.title}
          <Glyphicon glyph="repeat" style={{ marginLeft: '10px' }} className="fast-right-spinner" />
        </div>
      )
    }
    return (
      <div>
        {this.props.title}

        <span className="badge" style={{ marginLeft: '10px' }}>
          {this.props.length}
        </span>
      </div>
    )
  }
}
